import React, { useState, useEffect } from "react";
import GeneralTab from "../../../components/Synonyms/GeneralTab";
import "./Synonyms.scss";
import { useContext } from "react";
import { ProductContext } from "../../../store";

const SynonymsList = () => {
	const { currentWebsiteId } = useContext(ProductContext);
	return (
		<div className="synonyms-container">
			<h1>Synonyms</h1>
			<p className="synonyms-help-text">
				Improve your site's search accuracy by linking related words.
				<br />
				<strong>Synonyms:</strong> List common customer search terms (e.g.,
				macbook, apple laptop).
				<br />
				<strong>Search Term:</strong> Map them to the official term that shows
				results (e.g., Laptop).
			</p>
			<GeneralTab currentWebsiteId={currentWebsiteId} />
		</div>
	);
};

export default SynonymsList;
